import {useRef, useState, useEffect, useContext} from 'react';
import {Utils} from '../Utils';
import {OCCUPATION, OP_CO_MAP, OCCUPATION_CATEGORY_MAP} from '../Constants';
import {AppContext} from '../App';
import {BackButton} from './BackButton';
import {PostUtil} from './PostUtil';
import './StartPage.css';

function compute(courses)
{
	const ops = OCCUPATION;
	const map = OP_CO_MAP;
	let i = 0, k;
	const len = ops.length;
	const len2 = courses.length;
	let result = [];
	let c;
	let r;
	for(; i < len; i++)
	{
		r = 0;
		for (k = 0; k < len2; k++)
		{
			c = courses[k];
			if(map[i][c] === 1)
			{
				r++;
			}
		}
		if(r)
		{
			result.push({i, r});
		}
	}

	result.sort((a, b) => a.r > b.r ? -1 : (a.r === b.r === 0 ? 0 : 1));
	let result2 = result.filter((v) => v.r === 3);
	if(result2.length >= 3)
	{
		if(result2.length > 10)
		{
			result2.length = 10;
		}
		result = result2;
	}
	else
	{
		if(result.length > 3)
		{
			result.length = 3;
		}
	}
	return result.map((v) => v.i);
}

export function StartPage({scene})
{
	const fh4 = Utils.tr('START_H2');
	const fname = Utils.tr('START_NAME');
	const femail = Utils.tr('START_EMAIL');
	const fphone = Utils.tr('START_PHONE');
	const btnText = Utils.tr('START_START');
	const fgrade = Utils.tr('CONTACT_Q1');
	const q11 = Utils.tr('CONTACT_Q1_OPT_1');
	const q12 = Utils.tr('CONTACT_Q1_OPT_2');
	const q13 = Utils.tr('CONTACT_Q1_OPT_3');
	const fsub = Utils.tr(scene === 'careers' ? 'START_SELECT': 'START_SELECT2');
	const formRef = useRef(null);
	const listRef = useRef(null);
	const scrollHintRef = useRef(null);
	const [selected, setSelected] = useState([]);
	const [errors, setErrors] = useState(null);
	const closure = useContext(AppContext);

	const onClick = (evt) =>
	{
		evt.preventDefault();

		const form = formRef.current;
		let name = form['name'];
		let email = form['email'];
		let phone = form['phone'];
		let grade = form['grade'];
		let errors = {};
		let info = {};
		let v;

		v = name.value.trim();
		if(!v)
		{
			errors['name'] = Utils.tr('FIELD_REQUIRED');
		}
		else
		{
			info['name'] = v;
		}
		v = email.value.trim();
		if(!v)
		{
			errors['email'] = Utils.tr('FIELD_REQUIRED');
		}
		else if(!v.match(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i))
		{
			errors['email'] = Utils.tr('INVALID_EMAIL');
		}
		else
		{
			info['email'] = v;
		}
		v = phone.value.trim();
		if(!v)
		{
			errors['phone'] = Utils.tr('FIELD_REQUIRED');
		}
		else if(!v.match(/^[\+]?[(]?[0-9]{1,}[)]?[-\s\.]?[0-9-\s]{3,}$/))
		{
			errors['phone'] = Utils.tr('INVALID_PHONE');
		}
		else
		{
			info['phone'] = v;
		}
		if(scene === 'courses' && selected.length !== 3)
		{
			errors['select'] = Utils.tr('INVALID_SELECT');
		}
		else if(!selected.length)
		{
			errors['select'] = Utils.tr('INVALID_SELECT_AT_LEAST');
		}
		v = grade.value;
		if(!v)
		{
			errors['grade'] = Utils.tr('FIELD_REQUIRED');
		}
		else
		{
			info['grade'] = v;
		}

		if(process.env.REACT_APP_SKIP_INPUT === undefined && Object.keys(errors).length)
		{
			let errs = form.querySelectorAll('.error.is-active');
			if(errs.length)
			{
				errs = Array.prototype.slice.call(errs, 0);

				let onTransEnd = () =>
				{
					errs[0].removeEventListener('transitionend', onTransEnd);
					setErrors(errors);
				};
				errs[0].addEventListener('transitionend', onTransEnd);
				errs.forEach((err) => {err.classList.remove('is-active')});
			}
			else
			{
				setErrors(errors);
			}

			if(errors.select)
			{
				closure.pushNotification({elm: (
					<div>
						<p>{errors.select}</p>
					</div>)
				, clazz: 'is-danger'
				});
			}
			return;
		}
		else
		{
			setErrors(null);
		}

		let selection;
		if(scene === 'careers')
		{
			selection = selected.slice(0).sort((a, b) => {return a - b;}); 
		}
		else
		{
			selection = compute(selected);
			info['courses'] = selected;
		}
		info['careers'] = selection;
		// closure.dispatch({type: 'push', page: 'course', args: {info}});

		let data = Object.assign({language: closure.lang}, info);
		if(scene === 'careers')
		{
			delete data['courses'];
		}
		else
		{
			delete data['careers'];
		}

		if(process.env.REACT_APP_SKIP_POST === undefined)
		{
			const target = evt.currentTarget;
			target.classList.add('is-loading');
			PostUtil.makeRequest('/v1/collect', data).then((resp) =>
			{
				if(PostUtil.handleResponse(resp, closure.pushNotification))
				{
					closure.dispatch({type: 'push', page: 'course', args: {info}});
					if('gtmOp' in window)
					{
						let rowset = Utils.tr(scene === 'careers' ? 'OCCUPATION_LIST' : 'COURSES_LIST');
						let rows = data[scene].map((v) => {return rowset[v];});
						window.gtmOp.push({'event': scene + '_selected', 'selection': rows, 'selected_grade': info?.grade});
					}
				}
				return resp;
			})
			.finally(() =>
			{
				target.classList.remove('is-loading');
			});
		}
		else
		{
			closure.dispatch({type: 'push', page: 'course', args: {info}});
		}
	};

	const onLiClick = (evt) =>
	{
		let li = evt.currentTarget;
		let idx = Number(li.getAttribute('data-index'));
		if(li.classList.contains('is-selected'))
		{
			li.classList.remove('is-selected');
			setSelected((prev) => {return prev.filter((row) => {return row !== idx;})});
		}
		else
		{
			setSelected((prev) =>
			{
				if(prev.length < 3)
				{
					return [...prev, idx];
				}
				return prev;
			});
		}
	};

	useEffect(() =>
	{
		let li;
		const ul = listRef.current;

		if(scene === 'careers')
		{
			li = ul.querySelectorAll('.selection-list > li');
		}
		else
		{
			li = ul.getElementsByTagName('LI');
		}
		let len = li.length;
		while(len--)
		{
			li[len].addEventListener('click', onLiClick);
		}

		const hint = scrollHintRef.current;
		const scrollToBottom = (evt) =>
		{
			hint.parentNode.scrollTo({top: hint.parentNode.scrollHeight, behavior: 'smooth'});
		}

		const positionScrollHint = (evt) =>
		{
			const target = evt ? evt.currentTarget : hint.parentNode;
			// console.log(target.scrollTop, target.scrollHeight, target.clientHeight);
			if(target.scrollTop + (40 + 100) + target.clientHeight > target.scrollHeight)
			{
				target.classList.add('is-end');
			}
			else
			{
				target.classList.remove('is-end');
			}
		};
		hint.parentNode.addEventListener('scroll', positionScrollHint);
		hint.addEventListener('click', scrollToBottom);
		positionScrollHint(null);

		return () =>
		{
			let len = li.length;
			while(len--)
			{
				li[len].removeEventListener('click', onLiClick);
			}

			hint.removeEventListener('click', scrollToBottom);
			hint.parentNode.removeEventListener('scroll', positionScrollHint);
		};

	}, [scene]);

	useEffect(() =>
	{
		const form = formRef.current;
		let errs = form.querySelectorAll('.error');
		if(!errs.length) return; 
		if(errors)
		{
			// let h = form.offsetWidth;
			errs.forEach((e) =>
			{
				if(errors.hasOwnProperty(e.getAttribute('data-field')))
				{
					e.classList.add('is-active');
				}
				else
				{
					e.classList.remove('is-active');
				}
			});
		}
		else
		{
			errs.forEach((e) =>
			{
				e.classList.remove('is-active');
			});
		}

	}, [errors]);

	const onBackBtnClick = () =>
	{
	//	closure.dispatch({type: 'pop'});
        window.history.back();
	};

	let userInfo = closure.userInfo;
	let rowset = Utils.tr(scene === 'careers' ? 'OCCUPATION_LIST' : 'COURSES_LIST');
	let section;

	if(scene === 'careers')
	{
		let rowCat = Utils.tr('OCCUPATION_CATEGORY_LIST');
		let catLen = rowCat.length;
		let j = 0;
		let cat = new Array(catLen);
		let iconMap = ['vial', 'compass-drafting', 'heart-pulse', 'chart-line', 'suitcase', 'suitcase'];
		for(; j < catLen; j++)
		{
			cat[j] = (
				<li className="category-item" key={j}>
					<p><i className={"fa pr-2 fa-lg fa-" + iconMap[j]}></i><span>{rowCat[j]}</span></p>
					<ul className="selection-list">
						{
							OCCUPATION_CATEGORY_MAP[j].map((mapping, i) =>
							{
								let row = rowset[mapping];
								return <ListItem label={row} key={i} index={mapping} selected={selected.indexOf(mapping) !== -1} />
							})
						}
					</ul>
				</li>
			);
		}

		section = (
			<ul className="category-list" ref={listRef}>
				{cat}
			</ul>
		);
	}
	else
	{
		section = (
			<ul className="selection-list" ref={listRef}>
				{
					rowset.map((row, i) =>
					{
						return <ListItem label={row} key={i} index={i} selected={selected.indexOf(i) !== -1} />
					})
				}
			</ul>
		);
	}

	return (
		<>
			<div className="columns is-desktop intro-area">
				<div className="column  is-8-desktop">
					<h4 className="title is-5 has-text-centered">{fsub}</h4>
				</div>
			</div>
			<div className={"columns is-desktop scene-area " + scene}>
				<div className="column is-8-desktop">
					<div className="box style-box occupation-box">
						<div className="scroll-box is-end">
							{section}
							<div className="scroll-hint" ref={scrollHintRef}>
								<span className="fa fa-chevron-down"></span>
								<span className="fa fa-chevron-down"></span>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-4-desktop">
					<div className="box style-box form-box">
						<h4 className="title is-3 has-text-centered">{fh4}</h4>
						<form method="post" action="#" ref={formRef}>
							<FormField label={fname} field="name" error={errors?.name} value={userInfo?.name} />
							<FormField label={femail} field="email" error={errors?.email} value={userInfo?.email} />
							<FormField label={fphone} field="phone" error={errors?.phone} value={userInfo?.phone} />
							<FormField label={fgrade} field="grade" error={errors?.grade}>
								<div className={"select is-rounded grade-select" + (errors?.grade ? " is-danger" : "")}>
									<select name="grade" defaultValue={userInfo.grade}>
										<option value=""></option>
										<option value="primary">{q11}</option>
										<option value="lower-secondary">{q12}</option>
										<option value="upper-secondary">{q13}</option>
									</select>
								</div>
							</FormField>
							<div className="block has-text-centered">
								<button onClick={onClick} className="button is-primary style-btn is-size-4">
									<span>{btnText}</span>
									<i className="fa fa-chevron-right"></i>
								</button>
							</div>
						</form>
					</div>
					<div className="block has-text-centered">
						<BackButton onClick={onBackBtnClick} />
					</div>
				</div>
			</div>
		</>
	)
}


function FormField({label, field, error, value, children})
{
	return (
		<div className="field">
			<label className="label">{label}</label>
			<div className="control">
				{children ? children : (<input className={"input" + (error ? " is-danger" : "")} type="text" name={field} defaultValue={value ?? ''} />)}
			</div>
			<p className="error" data-field={field}>{error}</p>
		</div>
	);
}

function ListItem({label, index, selected})
{
	return (
		<li data-index={index} className={selected ? 'is-selected' : ''}><span>{label}</span></li>
	);
}
